import { QueryClient } from '@tanstack/react-query';
import { STALE_TIME_SHORT, GC_TIME_DEFAULT } from '@/shared/constants/timing';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: STALE_TIME_SHORT,
      gcTime: GC_TIME_DEFAULT,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

export default queryClient;
